export interface PricingNumbers {
  documents: object;
  pricing: PricingItem[];
}

export interface PricingItem {
  availableForInitialNumber: boolean;
  availableToBuyWithoutSupport: boolean;
  city: string;
  countryCode: string;
  deliveryTime: string;
  hasMorePricings: boolean;
  id: number;
  prefix: string;
  price: number;
  priceInCents: number;
  priceSetup: number;
  requiredDocuments: string[];
  requiredDocumentsCodes: string[];
  setupPriceInCents: number;
  type: string;
  numberType: string;
  region: string;
}

export interface PricingItemTableRow extends PricingItem {
  buttonLabel: string;
  hasRequiredDocuments: boolean;
}

export interface PhoneNumber {
  number: string;
  id: number | string;
  didww: boolean;
}

export interface Country {
  isoCountry: string;
}

export interface PricingItemFilters {
  search: string;
  type: string;
  region: string;
  countryCode?: string;
}

export interface SelectedMsisdn {
  id: number;
  number: string;
}

export enum GetNumbersFromRegionState {
  CAN_CHOOSE_SPECIFIC_NUMBER = 'CAN_CHOOSE_SPECIFIC_NUMBER',
  CAN_GET_RANDOM_NUMBER = 'CAN_GET_RANDOM_NUMBER',
  NO_NUMBERS_FOUND = 'NO_NUMBERS_FOUND',
}

export type ActionType = 'ORDER' | 'ORDER_FREE' | 'GET_FREE' | 'BUY' | 'GET_INITIAL';

export interface OrderNumberRequest {
  pricingId: number;
  selectedMsisdn?: SelectedMsisdn;
  label: string;
}

export interface MsisdnRequestDto {
  label: string;
  pricingId: number;
  actionType: ActionType;
  selectedMsisdnId?: number | string;
  selectedMsisdnDisplayedValue?: string;
}

export interface MsisdnRequestDtoWithMetadata extends MsisdnRequestDto {
  countryCode: string;
  formatted: string;
}
